import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './global_styles.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App.tsx';

// Patch: Force passive event listeners for scroll-blocking events to improve performance
// and silence warnings from third-party libraries (like Bootstrap/Swiper/Choices.js)
(function () {
  if (typeof EventTarget !== 'undefined') {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    // @ts-ignore
    EventTarget.prototype.addEventListener = function (type: string, listener: any, options: any) {
      let newOptions = options;
      if (type === 'touchstart' || type === 'touchmove' || type === 'wheel') {
        if (typeof options !== 'object' || options === null) {
          // Default to passive=true if no options provided
          newOptions = { passive: true };
        } else if (typeof options === 'object' && options.passive === undefined) {
          // Add passive=true if not explicitly set
          newOptions = { ...options, passive: true };
        }
      }
      return originalAddEventListener.call(this, type, listener, newOptions);
    };
  }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
